import { render, staticRenderFns } from "./Satis.vue?vue&type=template&id=d04c06b4&scoped=true"
import script from "./Satis.vue?vue&type=script&lang=js"
export * from "./Satis.vue?vue&type=script&lang=js"
import style0 from "./Satis.vue?vue&type=style&index=0&id=d04c06b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04c06b4",
  null
  
)

export default component.exports